export default __webpack_public_path__ + "static/media/p1050310.8ae5c6c2-min.01adacbb.jpg";